import React, { useState } from "react";
import { Button, Form, Modal } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { productService } from "../../../Service/AllSalestoolAPI";
import swal from "sweetalert";
const CreateProductForm = ({ show, onHide }) => {
  const [submitting, setSubmitting] = useState(false);
  const [newProductData, setNewProductData] = useState({
    country: "",
    productName: "",
    productImage: "",
    brochure: "",
    subProductDetails: [],
  });

  const resetForm = () => {
    setNewProductData({
      country: "",
      productName: "",
      productImage: "",
      brochure: "",
      subProductDetails: [],
    });
  };

  const handleClose = () => {
    resetForm();
    onHide();
  };

  const handleBaseImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewProductData((prev) => ({ ...prev, productImage: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleBaseBrochureUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        swal("Invalid file", "Please upload a PDF file for the brochure.", "warning");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewProductData((prev) => ({ ...prev, brochure: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubProductImageUpload = (e, subIndex) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newDetails = [...newProductData.subProductDetails];
        newDetails[subIndex].subProductImage = reader.result;
        setNewProductData((prev) => ({ ...prev, subProductDetails: newDetails }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubProductBrochureUpload = (e, subIndex) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        swal("Invalid file", "Please upload a PDF file for the subproduct brochure.", "warning");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        const newDetails = [...newProductData.subProductDetails];
        newDetails[subIndex].subProductBrochure = reader.result;
        setNewProductData((prev) => ({ ...prev, subProductDetails: newDetails }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleTypeImageUpload = (e, subIndex, typeIndex) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newDetails = [...newProductData.subProductDetails];
        newDetails[subIndex].subProductTypes[typeIndex].typeImage = reader.result;
        setNewProductData((prev) => ({ ...prev, subProductDetails: newDetails }));
      };
      reader.readAsDataURL(file);
    }
  };

  const addSubProduct = () => {
    setNewProductData((prev) => ({
      ...prev,
      subProductDetails: [
        ...prev.subProductDetails,
        {
          subProductName: "",
          subProductImage: "",
          subProductBrochure: "",
          subProductTypes: [],
        },
      ],
    }));
  };

  const removeSubProduct = (subIndex) => {
    const newDetails = [...newProductData.subProductDetails];
    newDetails.splice(subIndex, 1);
    setNewProductData((prev) => ({ ...prev, subProductDetails: newDetails }));
  };

  const addType = (subIndex) => {
    const newDetails = [...newProductData.subProductDetails];
    newDetails[subIndex].subProductTypes.push({
      typeName: "",
      typeImage: "",
    });
    setNewProductData((prev) => ({ ...prev, subProductDetails: newDetails }));
  };

  const removeType = (subIndex, typeIndex) => {
    const newDetails = [...newProductData.subProductDetails];
    newDetails[subIndex].subProductTypes.splice(typeIndex, 1);
    setNewProductData((prev) => ({ ...prev, subProductDetails: newDetails }));
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      await productService.createProduct(newProductData);
      swal("Success!", "Product created successfully.", "success");
      handleClose();
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || "Unknown Error Occurred";
      swal("Failed!", errorMessage, "error");
    } finally {
      setSubmitting(false);
    }
  };

  const isFormValid = (() => {
    if (!newProductData.country || !newProductData.productName || !newProductData.productImage) return false;
    if (newProductData.subProductDetails.length === 0) return false;
    for (const sub of newProductData.subProductDetails) {
      if (!sub.subProductName || !sub.subProductImage) return false;
      if (sub.subProductTypes.length === 0) return false;
      for (const type of sub.subProductTypes) {
        if (!type.typeName || !type.typeImage) return false;
      }
    }
    return true;
  })();

  return (
    <>
      <style>{`
        @media (min-width: 992px) {
          .shift-right-modal {
            transform: translateX(190px) !important;
          }
        }
      `}</style>
      <Modal show={show} onHide={handleClose} size="lg" dialogClassName="shift-right-modal">
        <Modal.Header closeButton>
          <Modal.Title>Create New Product</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <Form>
            <h5 className="mb-3">1. Product Information</h5>
            <div className="p-3 border rounded mb-4 bg-light">
              <Form.Group className="mb-3">
                <Form.Label>Country Name <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  value={newProductData.country}
                  onChange={(e) => setNewProductData({ ...newProductData, country: e.target.value })}
                >
                  <option value="">Select Country</option>
                  <option value="India">India</option>
                  <option value="Portugal">Portugal</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Product Name <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g. Fuel Dispenser"
                  value={newProductData.productName}
                  onChange={(e) => setNewProductData({ ...newProductData, productName: e.target.value })}
                />
              </Form.Group>
                      <Form.Group className="mb-3">
                <Form.Label>Product Image <span className="text-danger">*</span></Form.Label>
                <Form.Control type="file" accept="image/*" onChange={handleBaseImageUpload} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Brochure PDF</Form.Label>
                <Form.Control type="file" accept="application/pdf" onChange={handleBaseBrochureUpload} />
              </Form.Group>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">2. Sub Products</h5>
              <Button variant="outline-success" size="sm" onClick={addSubProduct}>
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Add Sub Product
              </Button>
            </div>

            {newProductData.subProductDetails.map((sub, subIndex) => (
              <div key={subIndex} className="p-3 border rounded mb-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <strong className="text-primary">Sub Product {subIndex + 1}</strong>
                  <Button variant="outline-danger" size="sm" onClick={() => removeSubProduct(subIndex)}>
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>Sub Product Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g. Axon"
                    value={sub.subProductName}
                    onChange={(e) => {
                      const newDetails = [...newProductData.subProductDetails];
                      newDetails[subIndex].subProductName = e.target.value;
                      setNewProductData((prev) => ({ ...prev, subProductDetails: newDetails }));
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Sub Product Image <span className="text-danger">*</span></Form.Label>
                  <Form.Control type="file" accept="image/*" onChange={(e) => handleSubProductImageUpload(e, subIndex)} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Sub Product Brochure PDF</Form.Label>
                  <Form.Control type="file" accept="application/pdf" onChange={(e) => handleSubProductBrochureUpload(e, subIndex)} />
                </Form.Group>

                <div className="ms-4 mt-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">Types for {sub.subProductName || `Sub Product ${subIndex + 1}`}</h6>
                    <Button variant="outline-info" size="sm" onClick={() => addType(subIndex)}>
                      <FontAwesomeIcon icon={faPlus} className="me-1" />
                      Add Type
                    </Button>
                  </div>

                  {sub.subProductTypes.map((type, typeIndex) => (
                    <div key={typeIndex} className="p-3 border rounded mb-2 bg-white">
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted small">Type {typeIndex + 1}</span>
                        <Button variant="link" className="text-danger p-0" onClick={() => removeType(subIndex, typeIndex)}>
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </div>
                      <Form.Group className="mb-2">
                        <Form.Label className="small">Type Name <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                          type="text"
                          size="sm"
                          placeholder="e.g. Premium"
                          value={type.typeName}
                          onChange={(e) => {
                            const newDetails = [...newProductData.subProductDetails];
                            newDetails[subIndex].subProductTypes[typeIndex].typeName = e.target.value;
                            setNewProductData((prev) => ({ ...prev, subProductDetails: newDetails }));
                          }}
                        />
                      </Form.Group>
                      <Form.Group className="mb-0">
                        <Form.Label className="small">Type Image <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="file" size="sm" accept="image/*" onChange={(e) => handleTypeImageUpload(e, subIndex, typeIndex)} />
                      </Form.Group>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={!isFormValid || submitting}>
            {submitting ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateProductForm;
